import { useRef, useState } from "react";
import { ErrorType } from "@components/global/new/Error/Error";
import { UserForgotRequest } from "@services/auth";
import { useToasts } from "@utils/hooks/useToasts";
import useMediaQuery from "@utils/hooks/utils";
import { CommonModalPropsI } from "@components/HOC/withModals";
import { getFormValue } from "@utils/getFormValue";
import { makeNotifs } from "@utils/makeNotifs";
import useApiRequests from "@services/http/useApiRequest";
import { RecordResponse } from "@services/http/responses/BaseResponse";

interface Elems extends HTMLFormControlsCollection {
  email: HTMLInputElement;
}

interface MyForm extends HTMLFormElement {
  readonly elements: Elems;
}

interface ForgotModalControlI {
  readonly isMob: boolean;
  readonly isLoading: boolean;
  readonly errors?: ErrorType;
  readonly recaptcha?: boolean;

  //ref
  reCapRef: any;

  setRecaptchaResponse(r: string | undefined): void;
  onForgot(e: React.FormEvent<MyForm>): void;
}

export const useForgotModalControl = (
  props: CommonModalPropsI
): ForgotModalControlI => {
  const notifs = makeNotifs();
  const requests = useApiRequests();
  const { success } = useToasts();
  const [errors, setErrors] = useState<ErrorType>();
  const isMob = useMediaQuery("max", 500);
  const [recaptchaResponse, setRecaptchaResponse] = useState<
    string | undefined
  >();
  const reCapRef = useRef<any>();

  const onForgot = async (e: React.FormEvent<MyForm>) => {
    e.preventDefault();
    const elems = e.currentTarget.elements;
    const value = getFormValue(elems).email;
    if (!value.length) return setErrors({ fill: true });
    if (!recaptchaResponse) return;
    const data = await requests.enqueue<RecordResponse<string>>(new UserForgotRequest(value, recaptchaResponse));
    reCapRef.current.reset();
    if (!data) return;
    success(data.Record || notifs.ok.check_email);
    props.handleClose();
  };
  return {
    isMob,
    isLoading : requests.isLoading,
    errors,
    recaptcha: !!recaptchaResponse,
    reCapRef,

    setRecaptchaResponse,
    onForgot,
  };
};
